import React from "react";

export const PortGfGvInput = ({technicalData, onChange, errors}) => {
  const regExp = /[^a-zA-Z0-9]/g;

  const handlePortGvGfChange = (event) => {
    const value = event.target.value.replace(regExp, '').substring(0, 6);
    onChange('port_gf_gv', value.toUpperCase());
  }
  
  const hasError = errors && errors.length !== 0;
  
  return (
      <>
        <h6 className="text-xs font-bold text-gray-600 uppercase">Port
          GF-GV</h6>
        <div>
          <div className="flex items-center space-x-2">
            <input
                type="text"
                value={technicalData?.port_gf_gv || ''}
                onChange={handlePortGvGfChange}
                className={`flex-1 px-2 py-1 text-xs border rounded focus:outline-none focus:ring-1 ${
                hasError
                    ? "border-red-500 focus:ring-red-500"
                    : "border-gray-300 focus:ring-orange-500"
            }`}
                placeholder="Port GF-GV eintragen (max. 6 Zeichen)"
                maxLength={6}
            />
            {/* Spacer to maintain alignment with fields above that have scan buttons */}
            <div className="w-10"></div>
          </div>
          {hasError && (
              <p className="mt-1 text-xs text-red-500">{errors[0].defaultMessage}</p>
          )}
        </div>
      </>
  );
}